import { render, staticRenderFns } from "./free_badges.vue?vue&type=template&id=7c64a385&"
import script from "./free_badges.vue?vue&type=script&lang=js&"
export * from "./free_badges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports